import React from "react"
import { Link } from "gatsby"
import { css, jsx } from "@emotion/core"
import Button from "../button"

const MemberDirectoryLink = () => (
  <div css={{ marginTop: "25px", padding: "5px", marginBottom: "3rem" }}>
    <h3 css={{ marginBottom: "0.667rem", borderBottom: "1px dotted #abadb3" }}>
      View the Member Directory
    </h3>
    <p
      css={{
        fontSize: "0.85rem",
        textAlign: "justify",
        textJustify: "inter-word",
        marginBottom: "0.667rem",
      }}
    >
      Whether you are a resident or visitor, our directory will help connect you
      with trusted member com- panies. Search by name, category, or keyword to
      find the businesses you need!
    </p>
    <Button to="/industry/membership-directory" text="View Our Members" />
  </div>
)

export default MemberDirectoryLink
